<template>
  <div>
    <a id="first-anchor" name="#first" />
    <div class="first-section">
      <div class="first-section-container section-common">
        <div class="left-title">
          <div class="left-title-content">
            <p data-aos="fade-right" data-aos-duration="800" class="lab-title">
              <span style="color:#5DBA45">H</span>
              <span style="color:#F5B228">u</span>
              <span style="color:#F5811A">m</span>an
              <span style="color:#DE3A3E">P</span>opulation
              <span style="color:#953C95">O</span>mics
              <span style="color:#009DDD">G</span>roup</p>
            <p data-aos="fade-right" data-aos-duration="1200" class="lab-sub-title">Welcome to Human Population Omics Group at Fudan University</p>
            <div style="border-bottom:1px solid #4d72b6;width:440px;margin:20px 0px 20px 7px" />
            <el-row>
              <el-col :span="8">
                <router-link to="/article">
                  <div class="number-title">
                    {{ pubnum }}
                  </div>
                  <div class="number-content">
                    Published<br>Literature
                  </div>
                </router-link>
              </el-col>
              <el-col :span="8">
                <router-link to="/people">
                  <div class="number-title">
                    {{ membernum }}
                  </div>
                  <div class="number-content">
                    Lab<br>Members
                  </div>
                </router-link>
              </el-col>
              <el-col :span="8">
                <router-link to="/software">
                  <div class="number-title">
                    {{ swnum }}
                  </div>
                  <div class="number-content">
                    Developed<br>Software
                  </div>
                </router-link>
              </el-col>
            </el-row>
            <div class="title-btns">
              <router-link to="/article"><el-button style="background-color:#FF9300;border-color:#FF9300" type="primary">Publications</el-button></router-link>
              <router-link to="/about"><el-button style="margin-left:10px">Contact us<i style="margin-left:4px" class="el-icon-right" /></el-button></router-link>
            </div>
          </div>
        </div>
        <div class="right-images">
          <div data-aos="fade-up" data-aos-duration="1600" class="circle circle-11" />
          <div data-aos="fade-up" data-aos-duration="1600" class="circle circle-12" />
          <div data-aos="fade-up" data-aos-duration="1600" class="circle circle-21" />
          <div data-aos="fade-up" data-aos-duration="1600" class="circle circle-22" />
          <div data-aos="fade-up" data-aos-duration="1200" class="bcircle bcircle-11" />
          <div data-aos="fade-up" data-aos-duration="1200" class="bcircle bcircle-12" />
          <div data-aos="fade-up" data-aos-duration="1200" class="bcircle bcircle-21" />
          <div data-aos="fade-up" data-aos-duration="1200" class="bcircle bcircle-22" />
          <img data-aos="fade-up" data-aos-duration="800" class="ccircle ccircle-11" src="@/assets/img/labfeature/6.png">
          <img data-aos="fade-up" data-aos-duration="800" class="ccircle ccircle-12" src="@/assets/img/labfeature/7.png">
          <img data-aos="fade-up" data-aos-duration="800" class="ccircle ccircle-21" src="@/assets/img/labfeature/5.png">
          <img data-aos="fade-up" data-aos-duration="800" class="ccircle ccircle-22" src="@/assets/img/labfeature/8.png">
        </div>
      </div>
    </div>
    <a id="second-anchor" name="#second" />
    <div class="second-section">
      <div class="second-section-container section-common">
        <p class="section-title">Latest <span class="section-title-focus">News</span> of HumPOG</p>
        <div style="display:flex;flex-wrap:wrap">
          <news-card :news-list="newsList" />
        </div>
      </div>
    </div>
    <a id="third-anchor" name="#third" />
    <div class="third-section">
      <a name="#third" />
      <div class="third-section-container section-common">
        <p class="section-title">Research <span class="section-title-focus">Interests</span></p>
        <div class="research-interest-block" style="display:flex">
          <div class="avatar-xu-container">
            <div class="avatar-xu" />
            <div class="sticker" style="position:absolute;text-align:center;margin-top:100px;background-color:orange;font-size:12px;color:#fff;border-radius:50px;padding:0.1em 1em;font-weight:580">PI</div>
          </div>
          <div class="quote-xu">
            <span class="quote-mark"> “</span>
            <p class="research-interest" data-aos-duration="500"> Human Population Omics Group (HumPOG) aims at using computational approaches and developing new methods to dissect <span class="spot-light">genetic architecture of human populations</span>, quantitatively characterize <span class="spot-light">genetic & phenotypic diversity</span>, and reveal their <span class="spot-light">demographic history</span> and <span class="spot-light">adaptive divergence</span>.</p>
            <p class="research-interest" style="margin-top:1.5rem">While theoretical modeling and methodology development are critical parts of the research in HumPOG, <span class="spot-light">analysis of vast omics data at both individual and population levels</span> is an equally important practice toward understanding microevolution mechanisms in humans and Precision Medicine.</p>
            <p class="research-interest" style="margin-top:1.5rem"> HumPOG has the following research directions:</p>
            <p class="quote-mark" style="text-align:right"> ”</p>
          </div>
        </div>
        <div style="display:flex;justify-content:space-between;margin: 0 2rem;">
          <div>
            <div class="research-direction" style="background-color:#953C95;opacity:0.8">Genetic Structure & Demographic History</div>
            <div class="research-direction" style="background-color:#F5B228;opacity:0.8">Natural Selection & Local Adaptation</div>
            <div class="research-direction" style="background-color:#F5811A">
              Computational Biology & Bioinformatics
              <ol>
                <li>Development of new methods & algorithms</li>
                <li>Database construction and management</li>
                <li>Bioinformatics pipelines and computer tools</li>
                <li>Mathematical modeling and statistics</li>
              </ol>
            </div>
          </div>
          <div>
            <div class="research-direction" style="background-color:#DE3A3E;opacity:0.8">Genetic Admixture & Recombination</div>
            <div class="research-direction" style="background-color:#5DBA45;opacity:0.8">
              Population Omics towards Precision Medicine
              <ol>
                <li>Population Genomics</li>
                <li>Population Transcriptomics</li>
                <li>Population Epigenomics</li>
                <li>Population Metagenomics</li>
                <li>Population Phenomics</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a id="fourth-anchor" name="#fourth" />
    <div class="fourth-section">
      <div class="fourth-section-container section-common">
        <p class="section-title">Featured <span class="section-title-focus">Publications</span></p>
        <featured-article :item-list="featuredArticles" />
      </div>
    </div>
    <a id="fifth-anchor" name="#fifth" />
    <div class="fifth-section">
      <div class="fifth-section-container section-common">
        <p class="section-title">Related <span class="section-title-focus">Links</span></p>
        <related-links />
      </div>
    </div>
    <!--    <a id="sixth-anchor" name="#sixth" />-->
    <!--    <div class="sixth-section">-->
    <!--      <div class="sixth-section-container section-common">-->
    <!--        <p class="section-title">Organized <span class="section-title-focus">Conferences</span></p>-->
    <!--        <conferences />-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="move-down" @click="scrollToNextAnchor">
      <i class="el-icon-caret-bottom" />
    </div>
    <footbar />
  </div>
</template>

<script>
import FeaturedArticle from './components/FeaturedArticle'
import RelatedLinks from './components/RelatedLinks'
import Footbar from './components/Footbar'
// import Conferences from './components/Conferences.vue'
import NewsCard from './components/NewsCard'
import AOS from 'aos'
import 'aos/dist/aos.css'
import gsap from 'gsap'

export default {
  components: {
    FeaturedArticle,
    // Conferences,
    Footbar,
    NewsCard,
    RelatedLinks
  },
  data() {
    return {
      featuredArticles: [],
      featuredNews: [],
      newsList: [],
      number: 0,
      pubNum: 0,
      memberNum: 0,
      swNum: 0,
      banner: ''
    }
  },
  computed: {
    animatedNumber: function() {
      return this.tweenedNumber.toFixed(0)
    },
    pubnum: function() {
      return this.pubNum.toFixed(0)
    },
    membernum: function() {
      return this.memberNum.toFixed(0)
    },
    swnum: function() {
      return this.swNum.toFixed(0)
    }
  },
  mounted: async function() {
    await this.$http.get('/api/feature/numbers')
      .then((response) => {
        let { pubNum, memberNum, swNum } = response.data.data
        console.log(response.data)
        // 如果访问服务器错误 就显示以下数据(截止2022/5/11的统计)
        pubNum = pubNum || 141
        memberNum = memberNum || 45
        swNum = swNum || 16
        gsap.to(this.$data, { duration: 2, pubNum })
        gsap.to(this.$data, { duration: 2, memberNum })
        gsap.to(this.$data, { duration: 2, swNum })
      })
      .catch((error) => {
        console.error({
          message: 'Oops, there is an error when fetching feature numbers' + error,
          type: 'error'
        })
      })
    await this.$http.get('/api/pub/featured')
      .then((response) => {
        // handle success
        this.featuredArticles = response.data.data
      })
      .catch((error) => {
        console.error({
          message: 'Oops, there is an error when fetching article list' + error,
          type: 'error'
        })
      })
    await this.$http.get('/api/news/featured')
      .then((response) => {
        this.newsList = response.data.data
      })
      .catch((error) => {
        console.error({
          message: 'Oops, there is an error when fetching news list' + error,
          type: 'error'
        })
      })
    AOS.init()
  },
  methods: {
    scrollToNextAnchor() {
      const anchors = document.anchors
      for (let i = 0; i < anchors.length; i++) {
        const disToTop = anchors[i].getBoundingClientRect().top - 70
        if (disToTop > 200) {
          anchors[i].scrollIntoView({ behavior: 'smooth' })
          break
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fifth-section {
  background-color: rgb(238, 241, 249);
}
.move-down {
  color: #409EFF;
  font-size: 28px;
  position: fixed;
  bottom: calc(5vh);
  padding: 6px;
  left: 1320px;
  height: 40px;
  width: 40px;
  border-radius: 20px;
  background-color: #fff;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 6px 0px;
}
.move-down:hover {
  background-color: rgb(243, 246, 251);
}

.quote-xu {
  font-size:20px;
  padding-left: 2rem;
  color: white;
}
.research-direction {
  border-radius: 10px;
  padding: 1rem 1rem;
  line-height: 1.5;
  margin: 1.5rem 0;
  width: 100%;
  color: #fff;
  font-size: 20px;
  letter-spacing: 2px;
  font-weight: 520;
  box-shadow: .25rem .25rem .5rem rgba(0, 0, 0 ,0.2);
}
ol>li::before {
  content: '·';
  font-weight: 800;
  margin: 0 1rem
}
.research-interest {
  /* text-indent: 2em; */
  font-weight: 540;
}
.quote-mark {
  font-size: 40px;
  font-family: 'Times New Roman', Times, serif;
  font-weight: 650;
  align-items: center;
}
.research-interest-block {
  background: #0052D4;  /* fallback for old browsers */
  background: -webkit-linear-gradient(to left, #6FB1FC, #4364F7, #0052D4);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to left, #6FB1FC, #4364F7, #0052D4); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  border-radius: 25px;
  padding: 2rem 2rem;
  margin: 0 2rem;
  box-shadow: .25rem .25rem .5rem rgba(0, 0, 0 ,0.2);
}
.third-section {
  background: #fff;
}
.avatar-xu-container {
  width: 40%;
  border-right: 1px dashed #fff;
  display: flex;
  justify-content:center;
  align-items: center;
}
.avatar-xu {
  background-image: url('../../assets/img/avatar/xu.jpg');
  background-repeat: no-repeat;
  background-position: right 50% top 50%;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #fff;
  background-size:  100% auto;
  border: 3px solid #fff;
}
.section-title {
  font-size: 36px;
  margin-bottom: 40px;
  margin-left: 10px;
  text-align: center;
  font-weight: 520;
}
.section-title-focus {
  color: rgb(29, 117, 248);
  background-color: rgba(221, 234, 253, 0.541);
  padding: 5px 10px;
  border-radius: 10px;
}
.second-section-container {
  min-height: 520px;
}
.news-container {
  height: 520px;
}
.number-title {
  color: #fff;
  font-size: 40px;
  font-weight: 600;
  margin-left: 3px;
}
.number-content {
  color: #fff;
  font-size: 18px;
  margin-left: 4px;
  margin-bottom: 10px;
  margin-top: 3px;
}
.section-common {
  width:1240px;
  margin: auto;
  padding: 2rem 0;
  min-height: 500px;
}
.first-section-container {
  display: flex;
  /* justify-content: space-between; */
}
.first-section {
  width: 100%;
  height: calc(100vh - 70px);
  min-height: 600px;
  padding-top: 70px;
  background: #0575E6;
  background: -webkit-linear-gradient(to left, #021B79, #0575E6);
  background: linear-gradient(to left, #021B79, #0575E6);
  padding: 0px;
  text-align: center;
}
.sixth-section {
  background: white;
}
.left-title {
  display: flex;
  align-items: center;
  text-align: left;
  width: 40%;
  height: calc(100vh - 200px);
  min-height: 400px;
}

.lab-title {
  font-style:italic;
  margin-top: 5x;
  margin-left: 7px;
  font-size: 48px;
  font-weight: 580;
  color: #fff;
}
.lab-sub-title {
  font-size: 18px;
  margin-top: 15px;
  margin-left: 7px;
  color: #fff;
}
.title-btns {
  margin-top: 15px;
}
.circle {
  width: 300px;
  height: 300px;
  border: 1px #a0a1a5 solid;
  -webkit-border-radius: 150px;
  border-radius: 150px;
  position:absolute;
  /* box-shadow: 0 0.125rem 0.625rem -0.1875rem rgb(0 0 0 / 10%); */
}
.circle-11 {
  width: 400px;
  height: 400px;
  -webkit-border-radius: 200px;
  border-radius: 200px;
  margin-top: 60px;
}
.circle-12 {
  width: 400px;
  height: 400px;
  -webkit-border-radius: 200px;
  border-radius: 200px;
  margin-top: 10px;
  margin-left: 280px;
}
.circle-21 {
  margin-top: 360px;
}
.circle-22 {
  margin-top: 290px;
  margin-left: 330px;
}
.bcircle {
  width: 200px;
  height: 200px;
  -webkit-border-radius: 100px;
  border-radius: 100px;
  position:absolute;
  background: rgb(27, 63, 160);  /* fallback for old browsers */
  box-shadow: 0.3rem 0.625rem 0.625rem -0.2875rem rgb(0 0 0 / 10%);

}
.bcircle-11 {
  margin-top: 70px;
  margin-left: 340px;
  z-index: 1000;
}
.bcircle-12 {
  margin-top: 250px;
  margin-left: 460px;
}
.bcircle-21 {
  width: 140px;
  height: 140px;
  border-radius: 70px;
  -webkit-border-radius: 70px;
  border-radius: 70px;
  margin-top: 360px;
  margin-left: 20px;
  z-index: 1200;
}
.bcircle-22 {
  width: 300px;
  height: 300px;
  -webkit-border-radius: 150px;
  border-radius: 150px;
  margin-top: 320px;
  margin-left: 120px;
}
.ccircle {
  width: 200px;
  height: 200px;
  border-radius: 100px;
  -webkit-border-radius: 100px;
  position:absolute;
  box-shadow: 0.3rem 0.625rem 0.625rem -0.1875rem rgb(0 0 0 / 10%);
}
.ccircle-11 {
  width: 300px;
  height: 300px;
  -webkit-border-radius: 150px;
  border-radius: 150px;
  margin-top: 120px;
  margin-left: 60px;
  z-index: 1400;
  background: #8E2DE2;  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #4A00E0, #8E2DE2);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #4A00E0, #8E2DE2); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
.ccircle-12 {
  margin-top: 10px;
  margin-left: 450px;
  background: #CAC531;  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #F3F9A7, #CAC531);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #F3F9A7, #CAC531); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  z-index: 1400;
}
.ccircle-21 {
margin-top: 460px;
background: #2980B9;  /* fallback for old browsers */
background: -webkit-linear-gradient(to right, #FFFFFF, #6DD5FA, #2980B9);  /* Chrome 10-25, Safari 5.1-6 */
background: linear-gradient(to right, #FFFFFF, #6DD5FA, #2980B9); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
z-index: 1200;
}
.ccircle-22 {
  margin-top: 320px;
  margin-left: 320px;
  width: 360px;
  height: 360px;
  -webkit-border-radius: 180px;
  border-radius: 180px;
  z-index: 1400;
background: #ADA996;  /* fallback for old browsers */
background: -webkit-linear-gradient(to right, #EAEAEA, #DBDBDB, #F2F2F2, #ADA996);  /* Chrome 10-25, Safari 5.1-6 */
background: linear-gradient(to right, #EAEAEA, #DBDBDB, #F2F2F2, #ADA996); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

</style>
